module.exports = __webpack_public_path__ + "img/picovie.243aacd3.png";